function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.1954 3C10.7861 3 10.3667 3.138 10.07 3.42225C9.77422 3.705 9.63022 4.107 9.63022 4.5V5.25H4.93457V6.75H5.71718V18.75C5.71718 19.9837 6.77761 21 8.06501 21H17.4563C18.7437 21 19.8041 19.9837 19.8041 18.75V6.75H20.5867V5.25H15.8911V4.5C15.8911 4.10775 15.7471 3.70575 15.4505 3.4215C15.1554 3.138 14.7352 3 14.3259 3H11.1954ZM11.1954 4.5H14.3259V5.25H11.1954V4.5ZM7.2824 6.75H18.2389V18.75C18.2389 19.1663 17.8907 19.5 17.4563 19.5H8.06501C7.63066 19.5 7.2824 19.1663 7.2824 18.75V6.75ZM8.84761 9V17.25H10.4128V9H8.84761ZM11.978 9V17.25H13.5433V9H11.978ZM15.1085 9V17.25H16.6737V9H15.1085Z",
  fill: "#E65C47"
});

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f2ea3377.svg";
export { ForwardRef as ReactComponent };